import { FileText, Image as ImgIcon, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { dateShort } from "@/lib/format";

export const DocItem = ({ doc, onOpen, onDelete, showUploader = true, extra = null }) => {
  const Icon = doc.content_type?.startsWith("image/") ? ImgIcon : FileText;
  return (
    <div className="flex items-center gap-2 rounded-xl border border-slate-200 bg-white pr-1 transition-colors hover:bg-slate-50" data-testid={`doc-item-${doc.id}`}>
      <button onClick={() => onOpen(doc)} className="flex-1 min-w-0 flex items-center gap-3 p-3 text-left" data-testid={`doc-open-${doc.id}`}>
        <Icon className="w-5 h-5 shrink-0 text-[#002FA7]" />
        <div className="min-w-0">
          <div className="font-medium text-sm truncate">{doc.original_filename}</div>
          <div className="text-xs text-slate-500">
            {showUploader && doc.uploaded_by_name ? `by ${doc.uploaded_by_name} · ` : ""}{dateShort(doc.uploaded_at)}
          </div>
          {extra && <div className="mt-1 flex flex-wrap gap-1.5">{extra}</div>}
        </div>
      </button>
      {onDelete && (
        <Button
          variant="ghost"
          size="icon"
          onClick={() => onDelete(doc)}
          className="shrink-0 text-slate-400 hover:text-rose-600 hover:bg-rose-50"
          aria-label={`Delete ${doc.original_filename}`}
          data-testid={`doc-delete-${doc.id}`}
        >
          <Trash2 className="w-4 h-4" />
        </Button>
      )}
    </div>
  );
};
